module.exports = __webpack_public_path__ + "static/media/zeya_walk_01.3d077961.svg";